var bowser = require("node_modules/bowser/bowser");

angular.module("core").constant(
    "bowser", bowser
);



//////////////////
// WEBPACK FOOTER
// ./core/bowser/bowser.constant.js
// module id = 379
// module chunks = 0